/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { UserInfo } from "../../models/http/user/user-info.model";

@Injectable({
	providedIn: "root"
})
export class UserStateService {
	private _userInfo = new BehaviorSubject<UserInfo>({
		name: "",
		surname: "",
		username: "",
		email: "",
		description: "",
		dcEnabled: true,
		role: "",
		tenants: []
	});
	public userInfo$ = this._userInfo.asObservable();

	public get userInfo(): UserInfo {
		return this._userInfo.value;
	}

	/**
	 * Updates the current user information.
	 *
	 * @param user - The user information to set.
	 */
	public setUser(user: UserInfo) {
		this._userInfo.next(user);
	}
}
